import { useEffect } from "react";
import { useThree } from "@react-three/fiber";
import type { Quality } from "../state/journeyMachine";

const QUALITY_DPR: Record<Quality, [number, number]> = {
  baja: [0.75, 1],
  media: [1, 1.5],
  alta: [1, 2],
};

/**
 * Ajusta dpr y sombras del renderer según el selector de calidad.
 */
export function QualityManager({ quality }: { quality: Quality }) {
  const gl = useThree((s) => s.gl);

  useEffect(() => {
    const [min, max] = QUALITY_DPR[quality];
    const dpr = Math.min(Math.max(window.devicePixelRatio, min), max);
    gl.setPixelRatio(dpr);
    gl.shadowMap.enabled = quality !== "baja";
  }, [gl, quality]);

  return null;
}
